<template>
    <div class="globalAd">
        <myMaks style="background: rgba(0,0,0,.75);"></myMaks>
        <scrollview class="globalAd-wrapper">
            <ul :class="[channelId == 105 ?'globalAd-pic-other':'globalAd-pic']">
                <v-touch @tap="cancel" class="cancel-icon"><img src="../../assets/activity/1212/btn_close.png"></v-touch>
                <v-touch @tap="confirm" class=" confirm">马上购买</v-touch>
                <!-- <v-touch @tap="cancel" class="cancel">放弃活动，继续测试</v-touch> -->
            </ul>
        </scrollview>
    </div>
</template>

<script>
    import {setCookie} from '@/frontend-lib/tools/cookies'
    import scrollview from '@/components/common/scrollview'
    import myMaks from '@/components/common/mask'
    export default {
        name: 'globalAd',
        components: {
            myMaks,
            scrollview
        },
        props: {
            confirmRoute: {
                required: true,
            },
            cancelRoute: {
                required: true,
            },
            period: {
                // 周期
                required: false,
                type: [String, Number],
            },
        },
        mounted(){
            if (this.period) {
                setCookie({
                    key: 'cpPromotionGlobalAdShowed',
                    value: 1,
                    timeMinSec: this.period
                })
                // this.back();
            }
        },
        methods: {
            stopScroll () {
                event.preventDefault();
                event.stopPropagation();
            },
            confirm () {
                this.close()
                if (this.confirmRoute) {
                    let route = this.$router.matcher.match(this.confirmRoute);
                    if (typeof(this.confirmRoute) === 'function') {
                        this.confirmRoute();
                    } else if (route) {
                        setTimeout(() => {
                            if (route.fullPath) {
                                this.$router.push(route.fullPath);
                            }
                        }, 500)
                    }

                }
            },
            cancel () {
                this.close()
                if (this.cancelRoute) {
                    // 有可能是undefined, undefined表示不跳转
                    let route = this.$router.matcher.match(this.cancelRoute);
                    if (typeof(this.cancelRoute) === 'function') {
                        this.cancelRoute();
                    } else if (route) {
                        setTimeout(() => {
                            if (route.fullPath) {
                                this.$router.push(route.fullPath);
                            }
                        }, 500)
                    }
                }
            },
            close () {
                this.$emit('close');
                if (this.period) {
                    setCookie({
                        key: 'cpPromotionGlobalAdShowed',
                        value: 1,
                        timeMinSec: this.period
                    })
                }
            },
            pushHistory() {
                let state = {
                    title: 'title',
                    url: "#"
                }
                window.history.pushState(state, state.title, state.url)
            },
            back() {
                const that = this;
                that.pushHistory();
                window.addEventListener("popstate", function (e) {
                    that.close();
                    location.href = `${location.origin}${location.pathname}?channelId=${that.channelId}#${that.$route.path}`;
                    //返回键重定向当前页面
                }, false);
            }
        },
        destroyed() {
            this.close();
        }
    }
</script>

<style lang="scss">
    @import '../../scss/config';
    @import '../../scss/function';

    .globalAd {
        position: fixed;
        z-index: 11;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        &-wrapper {
            position: absolute;
            width: topx(750rem);
            height: 100vh;
            left:50%;
            transform: translate(-50%, 0);
            z-index: 11;
        }
        &-pic {
            width: topx(600rem);
            height: topx(640rem);
            // background: url('../../assets/activity/newYear/newyears-dialog-bg.jpg');
            background-size: topx(600rem);
            position: absolute;
            left: 50%;
            margin-left: topx(-300rem);
            top: 14.4%;
            border-radius: topx(18rem);
            .confirm {
                position: absolute;
                bottom: topx(62rem);
                left: 50%;
                width: topx(400rem);
                height: topx(80rem);
                transform: translate(-50%, 0);
                line-height: topx(78rem);
                border-radius: topx(16rem);
                color: #4C4B58;
                text-align: center;
                font-size: topx(36rem);
                background: #fcb92c;
                // background-image: linear-gradient(0deg, #FF8182 0%, #FF6869 100%);
                box-shadow: 0 topx(2rem) topx(4rem) 0 rgba(108,108,108,0.5);
            }
            .cancel {
                position: absolute;
                bottom: topx(96rem);
                left: 50%;
                font-size: topx(24rem);
                color: #fff;
                transform: translate(-50%, 0);
                padding-right: topx(30rem);
                &:after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: topx(2rem);
                    width: topx(28rem);
                    height: topx(28rem);
                    background: url('../../assets/arrow-right.png');
                    background-size: cover;
                }
            }
            .cancel-icon{
                width: topx(50rem);
                height: topx(50rem);
                position: absolute;
                right: topx(-25rem);
                top: topx(-25rem);
                img{
                    width: 100%;
                    height: auto;
                }
            }
        }
        &-pic-other {
            width: topx(600rem);
            height: topx(640rem);
            // background: url('../../assets/activity/newYear/dialog115.jpg');
            background-size: topx(600rem);
            position: absolute;
            left: 50%;
            margin-left: topx(-300rem);
            top: 14.4%;
            border-radius: topx(18rem);
            .confirm {
                position: absolute;
                bottom: topx(62rem);
                left: 50%;
                width: topx(400rem);
                height: topx(80rem);
                transform: translate(-50%, 0);
                line-height: topx(78rem);
                border-radius: topx(16rem);
                color: #4C4B58;
                text-align: center;
                font-size: topx(36rem);
                background: #fcb92c;
                // background-image: linear-gradient(0deg, #FF8182 0%, #FF6869 100%);
                box-shadow: 0 topx(2rem) topx(4rem) 0 rgba(108,108,108,0.5);
            }
            .cancel {
                position: absolute;
                bottom: topx(96rem);
                left: 50%;
                font-size: topx(24rem);
                color: #fff;
                transform: translate(-50%, 0);
                padding-right: topx(30rem);
                &:after {
                    content: '';
                    position: absolute;
                    right: 0;
                    top: topx(2rem);
                    width: topx(28rem);
                    height: topx(28rem);
                    background: url('../../assets/arrow-right.png');
                    background-size: cover;
                }
            }
            .cancel-icon{
                width: topx(50rem);
                height: topx(50rem);
                position: absolute;
                right: topx(-25rem);
                top: topx(-25rem);
                img{
                    width: 100%;
                    height: auto;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/promotion/global_ad.vue